import React from 'react';
import { classSongMap, formatClassDuration } from '@/state/classSteps';

export function ClassSongMap({ bpm, flow = 1, mapId = null, onAddMarkers, highlighted = false }) {
  const map = classSongMap(bpm, flow, mapId);
  const counts = {};
  return <section className="class-song-map" data-testid="class-song-map">
    <div className="class-song-map-heading"><strong>Song map</strong><span>{map.length} bars · {formatClassDuration(map.length, bpm)}</span></div>
    <div className="class-song-map-strip">{map.sections.map((section) => { counts[section.name] = (counts[section.name] || 0) + 1; return <div key={`${section.name}-${section.startBar}`} style={{ '--section-color': section.color, flex: section.bars }}>
      <span>{section.name}{counts[section.name] > 1 ? ` ${counts[section.name]}` : ''}</span><small>{section.bars}</small>
    </div>; })}</div>
    <button data-testid="add-class-markers" className={highlighted ? 'class-highlight' : ''} onClick={onAddMarkers}>Add these markers for me</button>
  </section>;
}

export default ClassSongMap;
